import React from 'react';
import styled, { css } from 'styled-components';
import { PropTypes } from 'prop-types';

const SwitcherContainer = styled.div`
  margin-bottom: 10px;
  border-bottom: 1px solid #444;
  position: relative;
`;

const SwitcherList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 100%;
  background-color: #333;
  border: 1px solid #444;
  border-top: none;
  border-radius: ${({ compact }) => (compact ? '4px' : '0 0 4px 4px')};
  z-index: 10;
  overflow-y: auto;
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.3s ease-in-out,
    visibility 0.3s;
  max-height: 0;
  opacity: 0;
  visibility: hidden;

  ${({ isOpen }) =>
    isOpen &&
    css`
      max-height: 400px;
      opacity: 1;
      visibility: visible;
    `}
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #6c757d;
    border-radius: 2px;
  }
  scrollbar-width: thin;
  scrollbar-color: #6c757d transparent;
  ${({ $compact }) => $compact && 'left: 65px; bottom: 50%; z-index: 1000; width: 220px;'};
`;

const SwitcherTrigger = styled.div`
  padding: 8px 12px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;

  ${({ $compact, $hasAction }) =>
    $compact &&
    $hasAction &&
    css`
      gap: 4px;
      padding: 8px 4px;
    `}
`;

const SwitcherIconWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const DropdownIndicator = styled.div`
  position: absolute;
  bottom: -2px;
  left: 4px;
  width: 24px;
  height: 2px;
  background-color: #be1622;
  border-radius: 0 0 1px 1px;
  transform: scaleX(${({ $isOpen }) => ($isOpen ? 1 : 0)});
  transform-origin: left center;
  transition: transform 0.2s ease;
`;

const SwitcherAction = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;

  ${({ $compact }) =>
    $compact &&
    css`
      margin-left: 0;
    `}
`;

const SwitcherDropdown = ({
  compact,
  isOpen,
  hasManyItems,
  onToggle,
  icon,
  content,
  action,
  children,
}) => (
  <SwitcherContainer onClick={hasManyItems ? onToggle : undefined}>
    <SwitcherTrigger $compact={compact} $hasAction={Boolean(action)}>
      <SwitcherIconWrapper>
        {icon}
        {hasManyItems && <DropdownIndicator $isOpen={isOpen} />}
      </SwitcherIconWrapper>
      {content}
      {action && <SwitcherAction $compact={compact}>{action}</SwitcherAction>}
    </SwitcherTrigger>
    {hasManyItems && (
      <SwitcherList isOpen={isOpen} $compact={compact}>
        {children}
      </SwitcherList>
    )}
  </SwitcherContainer>
);

SwitcherDropdown.propTypes = {
  compact: PropTypes.bool,
  isOpen: PropTypes.bool,
  hasManyItems: PropTypes.bool,
  onToggle: PropTypes.func,
  icon: PropTypes.node,
  content: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
};

export default SwitcherDropdown;
